
import MeetingPage from '../../views/admin/meeting/meetingPage';

const MeetingLayout1 = () => {
    return (
      <div>
        {/* Meeting specific content goes here */}
        <MeetingPage />
      </div>
    );
  };
  
  export default MeetingLayout1;